import styled from 'styled-components';

const StyledPeopleCell = styled.div`
  position: relative;
  flex: 0 0 32%;
  max-width: 32%;
  margin: 0 .5% 80px;
  overflow: hidden;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  img{
    display: block;
    width: 100%;
    transition: filter .5s ease-in-out;
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
    margin-bottom: 40px;
  }
  img:hover {
    -webkit-filter: grayscale(0%); 
    filter: grayscale(0%);
  }
  .people--name{
    margin-bottom: 16px;
    color: #999999;
  }
  
  @media screen and (max-width: 1023px){
    margin-bottom: 64px;
    img{
      margin-bottom: 24px;
    }
    .people--name{
      margin-bottom: 8px;
    }
  }
  @media screen and (max-width: 767px){
    flex: 1 0 47%;
    max-width: 47%;
    margin-bottom: 40px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    img{
      margin-bottom: 16px;
    }
  }
`;

export {
  StyledPeopleCell,
};

